module.exports = {
  title: 'Balance Slider with Reanimated',
  author: 'Enzo Manuel Mangano',
  date: '2024-01-21',
  slug: 'balance-slider',
  tags: ['reanimated', 'gesture-handler'],
};
